import { removeAccents } from "@/common/utils/removeAccents"
import { twMerge } from "tailwind-merge"

export const renderHighlightedText = (
  text: string,
  search: string,
  active: boolean
) => {
  if (!search.trim()) return text

  const normalizedText = removeAccents(text.toLowerCase())
  const normalizedSearch = removeAccents(search.toLowerCase())

  const index = normalizedText.indexOf(normalizedSearch)
  if (index === -1) return text

  const before = text.slice(0, index)
  const match = text.slice(index, index + search.length)
  const after = text.slice(index + search.length)

  return (
    <>
      {before}
      <span
        className={twMerge(
          'rounded text-black-900',
          active ? 'bg-yellow-500' : 'bg-yellow-200'
        )}
      >
        {match}
      </span>
      {after}
    </>
  )
}